"use strict";

require("core-js/modules/es6.string.anchor");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Portal = function Portal(props) {
  var anchor = props.anchor,
      children = props.children;
  var container = (0, _react.useMemo)(function () {
    if (anchor) {
      return anchor;
    }

    if (typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.body !== 'undefined') {
      return window.document.body;
    }

    return null;
  }, [anchor]);

  if (!container) {
    return null;
  }

  return _reactDom["default"].createPortal((0, _core.jsx)(_react["default"].Fragment, null, children), container);
};

__signature__(Portal, "useMemo{container}");

var _default = Portal;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Portal, "Portal", "/builds/bA1zbJom/0/gojob/ui-bits/src/Portal/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Portal/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();